/* Our Tools and collection pages, phones: size each card photo to the tool in it.
   Photos are square with a lot of baked-in margin, and the card frame is
   taller than wide, so tall tools (Identibolts) looked small. For each photo,
   find the tool's bounding box, center it, and scale it up until it is 7% from
   the card edge (never smaller than the old 110%, never more than 220%). */
(function () {
  'use strict';
  // Sizing vars only take effect on phones (sst-base.css); the award clip applies everywhere.

  var BASE = 1.1, MAX = 2.2, MARGIN = 0.07, N = 96;
  var canvas = document.createElement('canvas');
  canvas.width = canvas.height = N;
  var ctx = canvas.getContext('2d', { willReadFrequently: true });

  function measure(img) {
    // Skip lazysizes' 1px placeholder; measure each real file once.
    if (!img.complete || img.naturalWidth < 50) return;
    var src = img.currentSrc || img.src;
    if (img.dataset.sstFit === src) return;
    img.dataset.sstFit = src;

    var px;
    try {
      ctx.clearRect(0, 0, N, N);
      ctx.drawImage(img, 0, 0, N, N);
      px = ctx.getImageData(0, 0, N, N).data;
    } catch (e) { return; } // cross-origin image: leave it at 110%

    function at(x, y) { var i = (y * N + x) * 4; return [px[i], px[i + 1], px[i + 2], px[i + 3]]; }
    var c = [at(1, 1), at(N - 2, 1), at(1, N - 2), at(N - 2, N - 2)];
    var bg = [0, 1, 2, 3].map(function (k) { return (c[0][k] + c[1][k] + c[2][k] + c[3][k]) / 4; });

    var minX = N, minY = N, maxX = -1, maxY = -1;
    var cols = new Array(N).fill(0);
    for (var y = 0; y < N; y++) {
      for (var x = 0; x < N; x++) {
        var p = at(x, y);
        if (p[3] < 24 && bg[3] < 24) continue; // transparent background
        var d = Math.abs(p[0] - bg[0]) + Math.abs(p[1] - bg[1]) + Math.abs(p[2] - bg[2]) + Math.abs(p[3] - bg[3]);
        if (d > 36) {
          cols[x]++;
          if (x < minX) minX = x; if (x > maxX) maxX = x;
          if (y < minY) minY = y; if (y > maxY) maxY = y;
        }
      }
    }
    if (maxX < 0) return;

    // object-fit: contain leaves spare room on one axis when the photo and the
    // card frame have different shapes. Work in card-frame units (0..1).
    var box = img.getBoundingClientRect();
    var fx = 1, fy = 1;
    if (box.width && box.height) {
      var k = Math.min(box.width / img.naturalWidth, box.height / img.naturalHeight);
      fx = (img.naturalWidth * k) / box.width;
      fy = (img.naturalHeight * k) / box.height;
    }
    var x0 = 0.5 + (minX / N - 0.5) * fx, x1 = 0.5 + ((maxX + 1) / N - 0.5) * fx;
    var y0 = 0.5 + (minY / N - 0.5) * fy, y1 = 0.5 + ((maxY + 1) / N - 0.5) * fy;
    var h = y1 - y0;
    // The main object is the heaviest run of occupied columns (so a side badge,
    // like the PTIA award, doesn't pull the tool off center). Keep it centered
    // and size so everything else still clears the edge.
    var best = null, run = null;
    for (var cx0 = 0; cx0 <= N; cx0++) {
      var filled = cx0 < N && cols[cx0] > 1;
      if (filled) {
        if (!run) run = { a: cx0, b: cx0, mass: 0 };
        run.b = cx0; run.mass += cols[cx0];
      } else if (run) {
        if (!best || run.mass > best.mass) best = run;
        run = null;
      }
    }
    // Card shows an award pill: hide the award baked into the photo (anything
    // left or right of the main object) and size from the main object alone.
    var card = img.closest('.sst-card');
    var hasAward = !!(best && card && card.querySelector('[data-sst-award]'));
    if (hasAward) {
      var pad = 1.5;
      var la = Math.max(0, best.a - pad), lb = Math.min(N, best.b + 1 + pad);
      var cl = (0.5 + (la / N - 0.5) * fx) * 100, cr = (100 - (0.5 + (lb / N - 0.5) * fx) * 100);
      img.style.clipPath = 'inset(0 ' + cr.toFixed(2) + '% 0 ' + cl.toFixed(2) + '%)';

      // Lift the award artwork itself out of the photo and show it as the
      // card's corner badge (same file, cropped with background-position).
      var bx0 = N, bx1 = -1, by0 = N, by1 = -1;
      for (var by = 0; by < N; by++) {
        for (var bx = 0; bx < N; bx++) {
          if (bx >= best.a - 1 && bx <= best.b + 1) continue;
          var bq = at(bx, by);
          var bd = Math.abs(bq[0] - bg[0]) + Math.abs(bq[1] - bg[1]) + Math.abs(bq[2] - bg[2]) + Math.abs(bq[3] - bg[3]);
          if (bd > 36 && !(bq[3] < 24 && bg[3] < 24)) {
            if (bx < bx0) bx0 = bx; if (bx > bx1) bx1 = bx;
            if (by < by0) by0 = by; if (by > by1) by1 = by;
          }
        }
      }
      var award = card.querySelector('[data-sst-award]');
      if (bx1 >= 0 && award) {
        bx0 = Math.max(0, bx0 - 1); by0 = Math.max(0, by0 - 1);
        bx1 = Math.min(N - 1, bx1 + 1); by1 = Math.min(N - 1, by1 + 1);
        var bw = (bx1 - bx0 + 1) / N, bh = (by1 - by0 + 1) / N; // fraction of the photo
        var frameEl = img.closest('.product-card__image-with-placeholder-wrapper') || img;
        var fw = frameEl.getBoundingClientRect().width;
        var wantW = fw * (window.matchMedia('(max-width: 749px)').matches ? 0.42 : 0.34);
        var aspect = img.naturalHeight / img.naturalWidth;
        var bgW = wantW / bw;                      // rendered width of the whole photo
        award.style.width = wantW.toFixed(1) + 'px';
        award.style.height = (bgW * aspect * bh).toFixed(1) + 'px';
        award.style.backgroundImage = 'url("' + (img.currentSrc || img.src) + '")';
        award.style.backgroundSize = bgW.toFixed(1) + 'px auto';
        award.style.backgroundPosition = (-bx0 / N * bgW).toFixed(1) + 'px ' + (-by0 / N * bgW * aspect).toFixed(1) + 'px';
        award.classList.add('is-logo');
      }
      x0 = 0.5 + (best.a / N - 0.5) * fx;
      x1 = 0.5 + ((best.b + 1) / N - 0.5) * fx;
      // vertical extent of the main object only
      var r0 = N, r1 = -1;
      for (var yy = 0; yy < N; yy++) {
        for (var xx = best.a; xx <= best.b; xx++) {
          var q = at(xx, yy);
          var dd = Math.abs(q[0] - bg[0]) + Math.abs(q[1] - bg[1]) + Math.abs(q[2] - bg[2]) + Math.abs(q[3] - bg[3]);
          if (dd > 36 && !(q[3] < 24 && bg[3] < 24)) { if (yy < r0) r0 = yy; if (yy > r1) r1 = yy; break; }
        }
      }
      if (r1 >= 0) { y0 = 0.5 + (r0 / N - 0.5) * fy; y1 = 0.5 + ((r1 + 1) / N - 0.5) * fy; h = y1 - y0; }
    }
    // Award cards center the main object (the badge is lifted out); every other
    // photo centers its whole content, so multi-item shots (bundles) stay balanced.
    var mc = hasAward ? 0.5 + (((best.a + best.b + 1) / 2) / N - 0.5) * fx : (x0 + x1) / 2;
    var half = 0.5 - MARGIN;
    var fit = Math.min((1 - 2 * MARGIN) / h, half / Math.max(mc - x0, 1e-3), half / Math.max(x1 - mc, 1e-3), MAX);
    // Per-product trim from the card (product tag "card-scale:0.75", or defaults in the snippet).
    var trim = parseFloat(card && card.getAttribute('data-sst-fit-scale'));
    if (trim > 0 && trim < 2) fit = Math.max(1, fit * trim);
    if (fit <= BASE && !(trim > 0)) return; // already as big as it can go: keep 110%

    var tx = -(mc - 0.5) * fit;
    var ty = -((y0 + y1) / 2 - 0.5) * fit;
    // Keep the tool clear of the award pill: nudge it down, never past the bottom margin.
    var pill = card && card.querySelector('[data-sst-award]');
    if (pill && box.height) {
      var frame = img.closest('.product-card__image-wrapper') || img;
      var fr = frame.getBoundingClientRect(), pr = pill.getBoundingClientRect();
      var need = (pr.bottom - fr.top + 8) / fr.height;           // top of tool must sit below this
      var top = 0.5 + fit * (y0 - 0.5) + ty;
      if (top < need) ty = Math.min(ty + (need - top), (1 - 0.03) - (0.5 + fit * (y1 - 0.5)));
    }
    // Apply the fitted size instantly (the zoom transition is for taps only).
    img.style.setProperty('transition', 'none', 'important');
    img.style.setProperty('--sst-img-scale', fit.toFixed(3));
    img.style.setProperty('--sst-img-x', (tx * 100).toFixed(2) + '%');
    img.style.setProperty('--sst-img-y', (ty * 100).toFixed(2) + '%');
    void img.offsetWidth;
    requestAnimationFrame(function () { img.style.removeProperty('transition'); });
  }

  function scan() {
    Array.prototype.forEach.call(document.querySelectorAll('.sst-card .product-card__image-wrapper img.grid-view-item__image'), measure);
  }

  document.addEventListener('lazyloaded', function (e) {
    if (e.target.matches && e.target.matches('.sst-card img.grid-view-item__image')) measure(e.target);
  });
  document.addEventListener('load', function (e) {
    if (e.target.matches && e.target.matches('.sst-card img.grid-view-item__image')) measure(e.target);
  }, true);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  else scan();
  window.addEventListener('load', scan);
})();
